/**
 * The bar at the bottom of a product page: the name, the price and the same buying button, kept in view while the page's own button is out of view, so the next step is always one tap
 * (a product page, a pooja or any item the shop sells). The button in the bar does what the page's own does (it is clicked for it), so nothing about buying is written twice. It sits
 * above the bottom navigation of the app shell when there is one, and it is only shown while the page's own button is out of view (below the fold or scrolled past).
 */
import { isPdp, getPdpMainBlock } from './pdp_context.js';

frappe.ready(function () {
	if (!isPdp()) return;
	var block = getPdpMainBlock();
	if (!block) return;

	var bar = null, observer = null, watched = null;

	function own() {  // the page's own buying button: the first visible primary action in the buying column
		var column = block.querySelector('.item-cart') || block;
		return Array.prototype.find.call(column.querySelectorAll('a.btn-primary, button.btn-primary'), function (b) { return !b.closest('.rfhq-buybar') && b.offsetParent !== null; }) || null;
	}
	function priceText() {
		var shown = block.querySelector('.product-price [itemprop="lowPrice"]') || block.querySelector('.product-price');
		return shown ? (shown.textContent || '').replace(/\s+/g, ' ').trim() : '';
	}
	function titleText() {
		var t = block.querySelector('.product-title, h1, h2');
		return t ? (t.textContent || '').trim() : '';
	}
	function build(button) {
		if (bar) bar.remove();
		bar = document.createElement('div');
		bar.className = 'rfhq-buybar';
		bar.hidden = true;
		var words = document.createElement('div');
		words.className = 'rfhq-buybar__words';
		var price = document.createElement('b'); price.className = 'rfhq-buybar__price'; price.textContent = priceText();
		var name = document.createElement('small'); name.className = 'rfhq-buybar__name'; name.textContent = titleText();
		words.append(price, name);
		var go = document.createElement('button');
		go.type = 'button';
		go.className = 'btn btn-primary rfhq-buybar__go';
		go.textContent = (button.textContent || '').trim();
		go.addEventListener('click', function () { var now = own(); if (now) now.click(); });
		bar.append(words, go);
		document.body.appendChild(bar);
	}
	function watch() {
		var button = own();
		if (!button) { if (bar) bar.hidden = true; return; }
		if (button === watched && bar) { bar.querySelector('.rfhq-buybar__price').textContent = priceText(); return; }
		watched = button;
		build(button);
		if (observer) observer.disconnect();
		if (!('IntersectionObserver' in window)) return;
		observer = new IntersectionObserver(function (entries) {
			var e = entries[0];
			bar.hidden = e.isIntersecting;  // shown whenever the page's own button is out of view, above or below
		});
		observer.observe(button);
	}

	watch();
	// The shop draws the buying column again when a variant is chosen: look again, so the bar follows the new button and the new price.
	var again = new MutationObserver(function () { window.clearTimeout(again._t); again._t = window.setTimeout(watch, 150); });
	again.observe(block, { childList: true, subtree: true });
});
